import { WarningIcon } from '@axa-japan/design-system-react/Icons';
import * as Dialog from '@radix-ui/react-dialog';

import React from 'react';

type CustomModalProps = {
  closeButtonRequired?: boolean;
  open: boolean;
  onClose: (open: boolean) => void;
  title?: string;
  isWarningModal?: boolean;
  children: React.ReactNode;
  buttonLabel?: string;
};

const CustomModal: React.FC<CustomModalProps> = ({ open, onClose, title, closeButtonRequired, children, buttonLabel, isWarningModal }) => {
  return (
    <Dialog.Root open={open} onOpenChange={onClose}>
      <Dialog.Portal>
        {/* Overlay (No click-to-close behavior) */}
        <Dialog.Overlay className="z-50 fixed inset-0 bg-black/50 backdrop-blur-sm" /> {/* Modal Content */}
        <Dialog.Content
          className="z-50 fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-white p-6 rounded shadow-xl !w-[552px]"
          onInteractOutside={(event) => {
            event.preventDefault();
          }}
          aria-describedby={undefined}
        >
          <div className="flex justify-between items-center">
            {isWarningModal ? (
              <div className="flex flex-col gap-3 justify-center items-center w-full">
                <div className="text-statusWarningDark ">
                  <WarningIcon size="large" />
                </div>
                <Dialog.Title className="text-center ">{title}</Dialog.Title>
              </div>
            ) : (
              <Dialog.Title className="text-center text-primitiveColors-grey800 text-2xl">{title}</Dialog.Title>
            )}

            {closeButtonRequired && <Dialog.Close className="text-gray-600 hover:text-gray-900 dark:hover:text-gray-300"> ✕ </Dialog.Close>}
          </div>

          <div className="mt-4 text-gray-700 dark:text-gray-300">{children}</div>
          <div className="mt-6 flex justify-end">
            <Dialog.Close className="px-6 py-4 bg-axaBlue text-white rounded hover:bg-cssColorVarMap-interactiveHoverPrimary-value font-bold">
              {buttonLabel}
            </Dialog.Close>
          </div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  );
};

export default CustomModal;
